// Copyright © 2021 Move Closer
import { FeedDirection } from './models';
export const CommentRepositoryType = Symbol.for('ICommentRepository');
export const ContentRepositoryType = Symbol.for('IContentRepository');
export const FeedEntriesRepositoryType = Symbol.for('IFeedEntriesRepository');
export const LiveFeedRepositoryType = Symbol.for('ILiveFeedRepository');
export const SearchRepositoryType = Symbol.for('ISearchRepository');
export const ReactionsRepositoryType = Symbol.for('IReactionsRepository');
